<div class="container">
  <div class="{{class}}">
    <div class="page">
      <ng-content></ng-content>
    </div>
  </div>
</div>
